import { Card } from 'primereact/card';
import React, { } from "react";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import userImage from '../../../assets/images/UserImage.png';
import { InputText } from 'primereact/inputtext';

export default function GraceMarksCard(props) {

    const subjectList = props?.student?.SubjectList || [];

    const handleMarksChange = (e, index, subject) => {
        props.onMarkeChange(props.student.StudentId, index, subject, e.value);

    };
    const marksEditor = (rowData, { rowIndex }) => {
        return (
            <InputText
                value={rowData?.GraceMark}
                onChange={(e) => handleMarksChange(e, rowIndex, rowData?.SubjectId)}
                style={{ width: "60px", height: "32px", textAlign: "center" }}
            />
        );
    };

    return (
        <div className="p-4">
            <div className="p-d-flex p-ai-center gap-4 p-py-2 mb-4 bg-white rounded-lg shadow-sm border border-gray-100">
                <img src={props?.student?.ProfilePic || userImage} alt="Student Profile" className="upload-preview shadow-sm" style={{ width: '80px', height: '80px', borderRadius: '50%', objectFit: 'cover', border: '2px solid #e5e7eb' }} />
                <div className='p-ml-2'>
                    <h3 className="text-xl font-bold text-gray-800 p-m-0">{props?.student?.StudentName || "Unknown Student"}</h3>
                    <p className="text-md text-gray-600 p-m-0">Roll No: <span className="font-semibold text-gray-800">{props?.student?.RollNo || "N/A"}</span></p>
                </div>
            </div>
            <hr className='p-m-0' />
            <Card className="mb-4" pt={{ body: { className: 'p-0' } }}>
                <DataTable value={subjectList} className='custom-table p-px-0' size='small' scrollable scrollHeight="calc(100vh - 310px)">
                    <Column header="Sr No." body={(rowData, { rowIndex }) => rowIndex + 1} />
                    <Column field="SubjectName" header="Subject Name" />
                    <Column field="ExamTypeName" header="Exam Type" />
                    <Column field="MarksGiven" header="Marks Given" />
                    <Column field="MarksRequired" header="Required Marks" />
                    <Column body={marksEditor} header="Grace Mark" />
                </DataTable>
            </Card>

        </div>
    );
}
